import getLang from 'I18n/utils/getLang';
import { getCategoriesByApiNamesRpc } from '../../../__generated__/chirp/com/hubspot/feature/store/rpc/FeatureCategoriesRpc';
import { rpcClient } from '../../rpcClient';
import { logRavenException } from '../../errorUtils';
export const fetchFeatureCategories = ({
  productApiNames,
  skuCategoryName
}) => {
  let featureCategories = [];
  let promiseError = undefined;
  return rpcClient.call(getCategoriesByApiNamesRpc, {
    request: {
      apiNames: productApiNames,
      i18nLangLocale: getLang()
    }
  }).then(featureCategoryResponseList => {
    const allFeaturesForRequestedProducts = [];
    for (const category of featureCategoryResponseList.categories) {
      for (const parentFeature of category.features) {
        allFeaturesForRequestedProducts.push(parentFeature.displayName);
        for (const childFeature of parentFeature.childrenFeatures) {
          allFeaturesForRequestedProducts.push(childFeature.displayName);
        }
      }
    }

    // Allow Data Hub to be displayed without the 5 feature minimum
    // https://hubspot.slack.com/archives/C02SM71SS5B/p1763394678184449?thread_ts=1763135001.112659&cid=C02SM71SS5B
    if (skuCategoryName !== 'OPERATIONS_HUB_PRODUCTS' && allFeaturesForRequestedProducts.length < 5) {
      const notEnoughFeaturesError = new Error(`fetchFeatureCategories: Not enough features to display. Expected at least 5 features.`);
      console.error(notEnoughFeaturesError);
      logRavenException({
        error: notEnoughFeaturesError,
        customMessage: notEnoughFeaturesError.message,
        additionalDetails: {
          productApiNames,
          allFeaturesForRequestedProductsCount: allFeaturesForRequestedProducts.length
        }
      });
      return [];
    }

    // Only display categories that have active features listed within them
    featureCategories = featureCategoryResponseList.categories.filter(category => category.features.length > 0);
  }, error => {
    promiseError = error;
    logRavenException({
      error,
      customMessage: error.message,
      additionalDetails: {
        productApiNames
      }
    });
  }).catch(error => {
    promiseError = error;
    logRavenException({
      error,
      customMessage: 'fetchFeatureCategories: Promise successfully resolved but the catch block was triggered',
      additionalDetails: {
        productApiNames
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    return featureCategories;
  });
};